//PREMIERLOCATION list
export const PREMIERLOCATION_LIST_REQUEST = 'PREMIERLOCATION_LIST_REQUEST';
export const PREMIERLOCATION_LIST_SUCCESS = 'PREMIERLOCATION_LIST_SUCCESS';
export const PREMIERLOCATION_LIST_FAIL = 'PREMIERLOCATION_LIST_FAIL';
